var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-menu"},[(!_vm.$isV2)?_c('Header',{ref:"header"}):_vm._e(),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }